import List from "@/components/list";
import router from "@/router";

const Table = (args) => {
  const { listeners, props } = args;
  const RCSelectionChange = listeners["selection-change"] || function() {};
  const deletePopup = listeners["deletePopup"] || function () { };
  const updateOnline = listeners["updateOnline"] || function () { };
  const toPopupUser = listeners["toPopupUser"] || function () { };
  // const canToInfo = listeners["canToInfo"] || false;
  // 编辑
  function editPopup(item) {
    router.push({ path: "/gbzjConfig/homePopup/add", query: { id: item.uuid } });
  }

  // 详情
  function toDetail(item) {
    router.push({ path: "/gbzjConfig/homePopup/detail", query: { id: item.uuid } });
  }

  //操作列按钮
  const Deal = ({ props: { vo } }) => {
    const item = vo.row;
    let dealConf = [];
    // 上线
    if (item.onlineStatus == 1) {
      dealConf.push(["icon-edit-disable", "编辑", () => { }, "popup:update"]);
      dealConf.push(["icon-delete-disable", "删除", () => { }, "popup:delete"]);
      dealConf.push([
        "icon-down",
        "下线",
        () => updateOnline(item.uuid, 0),
        "popup:online",
      ]);
    } else {
      dealConf.push([
        "icon-edit",
        "编辑",
        () => editPopup(item),
        "popup:update",
      ]);
      dealConf.push([
        "icon-delete",
        "删除",
        () => {
          deletePopup(item);
        },
        "popup:delete",
      ]);
      dealConf.push([
        "icon-up",
        "上线",
        () => updateOnline(item.uuid, 1),
        "popup:online",
      ]);
    }
    dealConf.push([
      "iconfont icdanchuangmingdan_sel iconfont-adapt",
      "弹窗名单",
      () => toPopupUser(item),
      "popup:user",
    ]);
    // dealConf.push(["iconfont icdanchuangmingdan_nor iconfont-adapt", "弹窗名单", () => alertUsers(item), "popup:user"],)
    return (
      <div class="deal-group">
        {dealConf.map((item) => (
          <el-tooltip content={item[1]} placement="top" v-permission={item[3]}>
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };

  const AlertName = ({ props: { vo } }) => {
    const item = vo.row;
    return (
      // class="no-padding"
      <div>
        {props.canToInfo ? (
          <el-button
            size="small"
            type="text"
            onClick={() => {
              toDetail(item);
            }}
          >
            {item.name}
          </el-button>
        ) : (
          <div>{item.name}</div>
        )}
      </div>
    );
  };

  const AlertTime = ({ props: { vo } }) => {
    const item = vo.row;
    return (
      <div>
        <div>{item.popupStartDate}</div>
        <div>{item.popupEndDate}</div>
      </div>
    );
  };

  const SyncStatus = ({ props: { vo } }) => {
    const item = vo.row;
    return (
      <div>
        <div>{item.pushStatusName}</div>
        <div>{item.pushDate}</div>
      </div>
    );
  };

  const AccountTableConfig = [
    {
      type: "selection",
      label: "main",
    },
    {
      label: "弹窗类型",
      prop: "bizTypeName",
      minWidth: "60",
      showOverflowTooltip: true,
    },
    {
      label: "弹窗标题",
      prop: "bizTypeName",
      minWidth: "150",
      showOverflowTooltip: true,
      render: (vo) => <AlertName vo={vo} />,
    },
    {
      label: "演讲人",
      prop: "lecturerNamePost",
      minWidth: "100",
      showOverflowTooltip: true,
    },
    {
      label: "课程开始时间",
      prop: "bizStartTime",
      minWidth: "120",
      showOverflowTooltip: true,
    },
    {
      label: "倒计时结束时间",
      prop: "countdownDate",
      minWidth: "120",
      showOverflowTooltip: true,
    },
    {
      label: "弹窗提醒时间",
      minWidth: "120",
      showOverflowTooltip: true,
      render: (vo) => <AlertTime vo={vo} />,
    },
    {
      label: "状态",
      prop: "onlineStatusName",
      minWidth: "50",
    },
    {
      label: "干部之家同步状态",
      minWidth: "120",
      render: (vo) => <SyncStatus vo={vo} />,
    },
    {
      label: "操作",
      minWidth: "140",
      fixed: "right",
      align: "center",
      render: (vo) => <Deal vo={vo} />,
    },
  ];
  return (
    <div>
      <List {...args} talbeCols={AccountTableConfig} onSelectionChange={RCSelectionChange}/>
    </div>
  );
};
export default Table;
